import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/ErrorPage'
import TimelineContainer from '@/components/timeline/Container'
import GalleryContainer from '@/components/gallery/Container'
import Photo from '@/components/gallery/Photo'
import MultipleProfileContainer from '@/components/profiles/multiple/Container'
import SingleProfileContainer from '@/components/profiles/single/Container'
import CreditContainer from '@/components/credits/Container'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      name: 'Timeline',
      component: TimelineContainer
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: GalleryContainer
    },
    {
      path: '/photos/:id',
      name: 'Photo',
      component: Photo
    },
    {
      path: '/profiles',
      name: 'Profiles',
      component: MultipleProfileContainer
    },
    {
      path: '/profiles/:id',
      name: 'Profile',
      component: SingleProfileContainer
    },
    {
      path: '/credits',
      name: 'Credits',
      component: CreditContainer
    },
    {
      path: '/error',
      name: 'Error Page',
      component: ErrorPage
    },
    {
      path: '*',
      redirect: '/error',
    }
  ],
  // Changed to avoid hash urls
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js